import React from "react";
import { Switch } from "@/components/ui/switch";

const Label = ({ children, className }: any) => (
    <label className={`text-2xl font-medium ${className || ""}`}>
        {children}
    </label>
);

export const BillSummaryTab = ({ settings, setSettings }: any) => {
    return (
        <div className="space-y-6">
            <div className="flex items-center gap-2">
                <Switch
                    checked={settings?.isBillSummary}
                    onCheckedChange={(checked) =>
                        setSettings({ ...settings, isBillSummary: checked })
                    }
                />
                <Label>Bill Summary</Label>
            </div>

            {settings?.isBillSummary && (
                <div className="ml-6 flex items-center gap-2">
                    <Switch
                        checked={settings?.isSkipBill}
                        onCheckedChange={(checked) =>
                            setSettings({ ...settings, isSkipBill: checked })
                        }
                    />
                    <Label>Skip button</Label>
                </div>
            )}
        </div>
    );
};
